export default __webpack_public_path__ + "mixxx.8d254a06.png";